/*
 *验证码登录
*/
import React from 'react'
import './inputSecret.less'
import api from '../../api/api.js'
import { Form, Input, Button,Select, message } from 'antd'
import {API_CONFIG} from '../../api/config.js'

class InputSecret extends React.Component {
    state = {
        login_loading: false,
    }
    componentDidMount(){

    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.setState({
                    login_loading: true
                })

                api.setSecret({
                    access_token: this.getQueryString('access_token'),
                    contact_secret: values.contact_secret,
                    out_contact_secret: values.out_contact_secret,
                }).then(res=>{

                    this.setState({
                        login_loading: false
                    })

                    if(res.code === 0){
                        this.weworkLogin();
                    }else{
                        message.error(res.message) 
                    }
                })
            }
        });
    }

    // 企业微信登录
    weworkLogin = () =>{
        api.weworkLogin({
            wework_token: this.getQueryString('access_token') 
        }).then(res => {
            this.setState({
                login_loading: false
            })
            if(res.code === 0){
                document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`    
                document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                window.location.href=`${API_CONFIG.yun_base}`
            }else{
                message.error(res.message)    
            }
        }).catch(err => {
            message.error('企业微信登录失败')
        })       
    }

    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
          r=window.location.search.substr(1).match(reg);
        }else{
          r=this.props.location.search.substr(1).match(reg);
        }
        if (r != null) return unescape(r[2]);
        return null;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { login_loading } = this.state;

        const formItemLayout = {
          labelCol: {span:6},
          wrapperCol: {span:15},
        };
        return (
            <div className="inputSecret">
                <p className="title">请先完成配置后开始使用物业云</p>
                <Form style={{paddingTop: 0}}  {...formItemLayout}>
                    <Form.Item label="通讯录管理secret">
                        {getFieldDecorator('contact_secret', {
                            rules: [
                                { required: true, message: '请输入通讯录管理secret'},
                            ],
                        })(<Input placeholder='请输入通讯录管理secret'/>)}
                    </Form.Item> 
                    <Form.Item label="外部联系人管理secret">
                        {getFieldDecorator('out_contact_secret', {
                            rules: [
                                { required: true, message: '请输入外部联系人管理secret'},
                            ],
                        })(<Input placeholder='请输入外部联系人管理secret'/>)}
                    </Form.Item>   

                </Form>
                <div className='submit-btn'>
                    <Button  
                        type="primary"
                        onClick={this.handleSubmit} 
                        loading={login_loading}
                    >提交</Button>
                </div>
            </div>
            
       )
    }
}
const InputSecretForm = Form.create({  })(InputSecret);
export default InputSecretForm;


// WEBPACK FOOTER //
// ./src/pages/inputSecret/inputSecret.jsx